import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const Box = ({ children }) => (
  <div className="min-h-screen grid place-items-center bg-[#0A0D14] p-6">
    <div className="max-w-md w-full text-center rounded-2xl border border-[#222B40] bg-[#111622] p-10 rise">{children}</div>
  </div>
);

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refreshUser } = useAuth();
  const [state, setState] = useState("checking");

  useEffect(() => {
    const sid = params.get("session_id");
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setState("paid"); refreshUser(); return; }
        if (["expired", "failed"].includes(data.payment_status)) return setState("failed");
      } catch { return setState("failed"); }
      if (++tries < 15) timer = setTimeout(poll, 2000); else setState("timeout");
    };
    poll();
    return () => clearTimeout(timer);
  }, [params, refreshUser]);

  return (
    <Box>
      {state === "checking" && <><Loader2 className="w-10 h-10 mx-auto animate-spin text-cyan-400" /><h1 className="mt-6 text-2xl font-bold text-white" data-testid="payment-checking">Confirmando tu pago…</h1></>}
      {state === "paid" && <><CheckCircle2 className="w-12 h-12 mx-auto text-emerald-400" /><h1 className="mt-6 text-2xl font-bold text-white" data-testid="payment-success">¡Pago confirmado!</h1><p className="mt-2 text-slate-400">Tus créditos ya están disponibles.</p></>}
      {state === "failed" && <><XCircle className="w-12 h-12 mx-auto text-red-400" /><h1 className="mt-6 text-2xl font-bold text-white" data-testid="payment-failed">El pago no se completó</h1></>}
      {state === "timeout" && <><h1 className="text-2xl font-bold text-white" data-testid="payment-timeout">Seguimos esperando la confirmación</h1><p className="mt-2 text-slate-400">Revisa tu facturación en unos minutos.</p></>}
      <Link to="/app/creditos" className="mt-8 inline-block px-5 py-2.5 rounded-full bg-blue-500 hover:bg-blue-400 text-white text-sm" data-testid="payment-back-btn">Volver a mi panel</Link>
    </Box>
  );
}

export function PaymentCancel() {
  return (
    <Box>
      <XCircle className="w-12 h-12 mx-auto text-amber-400" />
      <h1 className="mt-6 text-2xl font-bold text-white" data-testid="payment-cancelled">Pago cancelado</h1>
      <p className="mt-2 text-slate-400">No se realizó ningún cargo.</p>
      <Link to="/app/creditos" className="mt-8 inline-block px-5 py-2.5 rounded-full bg-blue-500 hover:bg-blue-400 text-white text-sm" data-testid="payment-back-btn">Volver</Link>
    </Box>
  );
}
